"use client"

import Link from "next/link";
import { usePathname } from "next/navigation";
import { Home } from 'lucide-react';
import {
  Sidebar,
  SidebarContent,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  useSidebar,
} from "@/components/ui/sidebar";
import { cn } from "@/lib/utils";
import { products } from "@/lib/products";
import { modules } from "@/lib/modules";

export function AppSidebar() {
  const { state } = useSidebar();
  const pathname = usePathname();

  const navItems = [
    { href: "/", icon: Home, label: "Home" },
    ...modules.map(moduleItem => ({
      href: moduleItem.href,
      icon: moduleItem.icon,
      label: moduleItem.title,
    }))
  ];

  const debtCastProduct = products.find((p) => p.slug === 'debtcast');
  const DebtCastIcon = debtCastProduct?.icon ?? Home;

  return (
    <Sidebar data-tour="sidebar">
      <SidebarHeader>
        <Link href="/" className="flex items-center gap-2">
          <DebtCastIcon className="h-8 w-8 shrink-0 text-primary" aria-hidden="true" />
          <span className={cn("font-semibold", state === 'collapsed' && 'hidden')}>
            DebtCast
          </span>
        </Link>
      </SidebarHeader>
      <SidebarContent>
        <SidebarMenu>
          {navItems.map((item) => {
            const dataTourAttr = item.href === '/modules/scenario-analysis' 
              ? 'scenario-analysis' 
              : item.href === '/modules/stochastic-projection'
              ? 'stochastic-projection'
              : undefined;
            
            return (
              <SidebarMenuItem key={item.label}>
                <SidebarMenuButton
                  asChild
                  isActive={pathname === item.href}
                  tooltip={item.label}
                  data-tour={dataTourAttr}
                >
                  <Link href={item.href}>
                    <item.icon className="h-5 w-5 shrink-0" />
                    <span className={cn(state === 'collapsed' && 'hidden')}>
                      {item.label}
                    </span>
                  </Link>
                </SidebarMenuButton>
              </SidebarMenuItem>
            );
          })}
        </SidebarMenu>
      </SidebarContent>
    </Sidebar>
  );
}
